'use strict';

// The android app cannot open its camera on its own: its shared file input handler
// asks for the photo library unless the input carries cordova_camera. This component
// owns that menu and, when create_input is set, the input the app hands the image to.
export class AndroidUploadMenu {
	constructor(component_key) {
		this.id = component_key;
		this.variables = yalwa.v.components[component_key] || {};
		this.$menu = null;
		this.$input = null;
		this.$target_input = null;
	}

	init() {
		if (!this.is_available()) {
			jQuery('.js-' + this.id + '_menu').remove();
			return;
		}

		this.$menu = jQuery('.js-' + this.id + '_menu');

		if (!this.$menu.length) {
			return;
		}

		this.setup_input();

		jQuery(document)
			.off('click.' + this.id, this.variables.trigger)
			.on('click.' + this.id, this.variables.trigger, (event) => {
				if (!this.is_available()) {
					return;
				}

				this.open(jQuery(event.currentTarget));
			});

		this.$menu
			.off('click', '[data-source]')
			.on('click', '[data-source]', (event) => {
				this.choose(jQuery(event.currentTarget));
			})
			.off('click', '.js-androiduploadmenu_cancel')
			.on('click', '.js-androiduploadmenu_cancel', () => {
				this.close();
			});
	}

	// The app hands the captured image to a blueimp bound input and never fires a change
	// event, so an input this component creates must be bound the same way. blueimp is
	// loaded lazily, which can be after this component inits.
	setup_input() {
		if (!this.variables.create_input) {
			this.$input = jQuery(this.variables.input);
			return;
		}

		const file_input = document.createElement('input');
		file_input.type = 'file';
		file_input.accept = 'image/*';
		file_input.style.display = 'none';
		file_input.className = 'js-' + this.id + '_upload_input';
		// blueimp takes the form field name from the input
		file_input.name = this.variables.input_name;
		document.body.appendChild(file_input);

		this.$input = jQuery(file_input);

		const bind_fileupload = () => {
			this.$input.fileupload(jQuery.extend(yalwa.basics.upload_defaults(), {
				url: this.variables.upload_url,
				done: (event, data) => {
					jQuery(document).trigger('androiduploadmenu_done', [data.result]);
				}
			}));
		};

		const wait_for_fileupload = window.setInterval(() => {
			if (typeof this.$input.fileupload === 'function') {
				window.clearInterval(wait_for_fileupload);
				bind_fileupload();
			}
		}, 100);
	}

	is_available() {
		return yalwa.v.is_phonegap && !yalwa.v.is_ios;
	}

	open($trigger) {
		this.$target_input = this.$input;

		if (this.$menu.parent().prop('tagName') !== 'BODY') {
			this.$menu.appendTo(document.body);
		}

		const dialog_z = parseInt($trigger.closest('.dialog').css('z-index'), 10);
		const base_z = Math.max(isNaN(dialog_z) ? 0 : dialog_z, 9);
		this.$menu.css('z-index', base_z + 2);
		yalwa.mobile.generic_shadow.show_queued({zindex: base_z + 1, onclick: () => {
			this.close();
		}});
		yalwa.basics.show(this.$menu);
	}

	choose($option) {
		const is_camera = $option.data('source') === 'camera';
		this.close();

		if (!this.$target_input || !this.$target_input.length) {
			return;
		}

		this.$target_input.prop('cordova_camera', is_camera);
		if (this.$target_input.prop('multiple')) {
			this.$target_input.prop('multiple', !is_camera);
		}
		this.$target_input[0].click();
	}

	close() {
		yalwa.basics.hide(this.$menu);
		yalwa.mobile.generic_shadow.hide_queued();
	}
}

const component_keys = Object.keys(yalwa.v.components).filter(component_key => component_key.startsWith('androiduploadmenu_'));

component_keys.map(component_key => {
	new AndroidUploadMenu(component_key).init();
});
